export default [["en-us", {
  "emc": {
    "away_status": {
      "false": "off",
      "indicator": "(Away)",
      "true": "on",
      "update_failed": "Failed to update your away status. Please try again.",
      "update_success": "Away message turned {status}"
    },
    "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
    "disabled_conversation_error": "Something went wrong on our end. Please refresh the page.",
    "empty_list_header": "Welcome to Secure Messaging",
    "empty_list_text": "You don't have any conversations yet",
    "general_error": "Something went wrong on our end. Please try again.",
    "message_placeholder": "Send a message",
    "message_status": {
      "delivered": "Delivered",
      "failed": "Failed to send. Click to retry",
      "sending": "Sending..."
    },
    "navigation": {
      "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
    },
    "new_line_hint": {
      "effect": "to add a new line",
      "keys": "Shift + Return"
    },
    "read_at": {
      "before_today": "Read {date} at {time}",
      "before_today_couple": "Read by {name} {date} at {time}",
      "today": "Read at {time}",
      "today_couple": "Read by {name} at {time}"
    },
    "retry_connection": "Retry connection",
    "send": "Send",
    "truncated_system_message": {
      "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
      "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
    },
    "unread_message_indicator": "Unread message indicator"
  },
  "errors": {
    "403": {
      "message": "Your SimplePractice user account does not have the necessary permission to access this page. If you believe you should have access, please contact your account administrator.",
      "title": "You do not have permission to access this page."
    },
    "404": {
      "message": "We can't find the page you're looking for, but we can help you find your way home.",
      "messageNoPractice": "We can't find the page you're looking for.",
      "title": "This page seems to be missing"
    },
    "500": {
      "message": "An unexpected error occurred. We have been notified of the error and are actively looking into it. This is a priority to resolve. Please try your request again in a few minutes.",
      "title": "An unexpected system error occurred."
    },
    "actions": {
      "errorCode": "Error code: {code}",
      "retry": "Retry",
      "takeHome": "Take me home"
    },
    "sessionTimeout": {
      "message": "Any progress you made was saved.<br>Go back to dashboard to continue<br>with documents.",
      "title": "Your session timed out"
    }
  },
  "home": {
    "header": {
      "existingClient": "Existing Client?"
    },
    "hero": {
      "contact": "Contact",
      "existingClient": "I'm an Existing Client",
      "newClient": "I'm a New Client"
    }
  }
}], ["es-mx", {
  "emc": {
    "away_status": {
      "false": "off",
      "indicator": "(Away)",
      "true": "on",
      "update_failed": "Failed to update your away status. Please try again.",
      "update_success": "Away message turned {status}"
    },
    "device_offline_error": "Your device seems to be offline, so sending messages won't work at the moment. We'll keep trying to reconnect, or you can retry.",
    "disabled_conversation_error": "Something went wrong on our end. Please refresh the page.",
    "empty_list_header": "Welcome to Secure Messaging",
    "empty_list_text": "You don't have any conversations yet",
    "general_error": "Something went wrong on our end. Please try again.",
    "message_placeholder": "Send a message",
    "message_status": {
      "delivered": "Delivered",
      "failed": "Failed to send. Click to retry",
      "sending": "Sending..."
    },
    "navigation": {
      "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
    },
    "new_line_hint": {
      "effect": "to add a new line",
      "keys": "Shift + Return"
    },
    "read_at": {
      "before_today": "Read {date} at {time}",
      "before_today_couple": "Read by {name} {date} at {time}",
      "today": "Read at {time}",
      "today_couple": "Read by {name} at {time}"
    },
    "retry_connection": "Retry connection",
    "send": "Send",
    "truncated_system_message": {
      "footer": "Your Account Owner can request a Data Export at any time from their account, contact them for more information.",
      "text": "Your Messaging history with this client prior to {date} is available via the Practice Data Export. {footer}"
    },
    "unread_message_indicator": "Unread message indicator"
  },
  "errors": {
    "403": {
      "message": "Tu cuenta de usuario de SimplePractice no tiene los permisos necesarios para acceder a esta página. Si crees que deberías tener acceso, contacta a tu administrador de cuenta.",
      "title": "No tienes permisos para acceder a esta página."
    },
    "404": {
      "message": "No podemos encontrar la página que buscas, pero podemos ayudarte a encontrar el camino a casa.",
      "messageNoPractice": "No podemos encontrar la página que buscas.",
      "title": "Esta página parece estar perdida"
    },
    "500": {
      "message": "Ocurrió un error inesperado. Hemos sido notificados del error y lo estamos investigando activamente. Esta es una prioridad para resolver. Por favor intenta tu solicitud nuevamente en unos minutos.",
      "title": "Ocurrió un error inesperado del sistema."
    },
    "actions": {
      "errorCode": "Código de error: {code}",
      "retry": "Reintentar",
      "takeHome": "Llévame a casa"
    },
    "sessionTimeout": {
      "message": "Cualquier progreso que hayas hecho fue guardado.<br>Regresa al panel para continuar<br>con los documentos.",
      "title": "Tu sesión expiró"
    }
  },
  "home": {
    "header": {
      "existingClient": "¿Cliente Existente?"
    },
    "hero": {
      "contact": "Contacto",
      "existingClient": "Soy un Cliente Existente",
      "newClient": "Soy un Cliente Nuevo"
    }
  }
}]];